import { Spotlight, SpotlightPulse, SpotlightTransition } from '@atlaskit/onboarding';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren, useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';

import messages from './messages.tsx';

export const SavedFiltersSpotlight = ({ children }: PropsWithChildren) => {
	const [isSpotlightActive, setIsSpotlightActive] = useState<boolean>(true);

	const { formatMessage } = useIntl();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const onDismiss = useCallback(() => {
		setIsSpotlightActive(false);

		// Dismisses the message so it is not displayed again to the user
		// @see https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/system-filters/#dismissal-check-filter
		void messageInstanceClicked({
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {},
			clickedElement: {
				buttonType: 'primary',
				clickedElement: 'button',
				clickIdentifier: 'dismiss',
			},
			messageEventType: 'clicked',
		});
	}, []);

	return (
		<>
			<SpotlightPulse radius={3} pulse={isSpotlightActive}>
				{children}
			</SpotlightPulse>
			{isSpotlightActive && (
				<SpotlightTransition>
					<Spotlight
						actions={[
							{
								onClick: onDismiss,
								text: formatMessage(messages.spotlightDismissButton),
							},
						]}
						heading={formatMessage(messages.spotlightTitle)}
						target="jira-nin-saved-filters-popup-content"
						targetRadius={3}
						dialogWidth={275}
						pulse={false}
						dialogPlacement="left top"
					>
						{formatMessage(messages.spotlightBody)}
					</Spotlight>
				</SpotlightTransition>
			)}
		</>
	);
};
